import React, { Component } from 'react';
import { Collapse, Card, CardBody, CardHeader, Col, Row, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, Alert } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import InputMask from 'react-input-mask';
import { Dropdown } from 'semantic-ui-react';
import { Search } from 'react-bootstrap-table2-toolkit';
// Components
import MyExportCSV from '../../components/exportCSV';
import BtnLoader from '../../components/Loaders/btnLoader';
import { socket } from '../../app-socket/socket';
import { WsEvents } from '../../app-socket/events';
import { onAddBattlefield, onDeleteBattlefield, onUpdateBattlefield, onUpdateBattlefieldPeriod } from '../../app-socket/events/battlefield';
import { getScreenHeight } from '../../helpers/screen_height_helper';
import { allowedDepartments } from '../../helpers/currency_helper';

import { Notification } from '../../components/Notifications/notifications';
// Helpers
// import { countryOptions } from '../../helpers/country_helper';
const CustomToggleList = ({ columns, onColumnToggle, toggles }) => (
  <div className='d-flex'>
    {columns
      .map((column) => ({
        ...column,
        toggle: toggles[column.dataField]
      }))
      .map((column, index) => {
        if (
          column.text === 'Country & City' ||
          column.text === "Client's Name" ||
          column.text === 'Sender' ||
          column.text === 'Source' ||
          column.text === 'Date' ||
          column.text === 'Payment Method' ||
          column.text === 'Commentary' ||
          column.text === 'Order Status'
        )
          return (
            <FormGroup key={index} className='d-flex ps-0 justify-content-between form-switch form-switch-lg form-group me-2'>
              <Label> {column.text}</Label>
              <Input name={column.text} onClick={() => onColumnToggle(column.dataField)} className='ms-4' id={column.text} type='checkbox' value={column.toggle ? 'true' : 'false'} />
            </FormGroup>
          );
      })}
  </div>
);

class FilterComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cards: [1],
      collapse: 1,
      error: '',
      year: '',
      month: '',
      paymentMethodFilter: '',
      orderStatusFilter: '',
      orderDate: '',
      clientName: '',
      selectedCountry: '', 
      countryError: '', 
      receivedDate: '',
      alert: null,
      correctDate: true,
      isChecked: allowedDepartments.includes(this.props.props.profileData.department.depName) ? true : false,
      isEdit: false,
      isNewClicked: false,
      modalNewPeriod: false,
      modalNewOrder: false,
      modalReceivedPayment: false,
      battle: [],
      my_filtered_battles: [],
      filtered_battles: [],
      payment_methods: [],
      payment_statuses: [],
      newTableColumns: []
    };
    this.toggleStickyFilter = this.toggleStickyFilter.bind(this);
    // functions to handle filter
    this.showAllOrders = this.showAllOrders.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleFilterDataSubmit = this.handleFilterDataSubmit.bind(this);
    this.resetFilterData = this.resetFilterData.bind(this);
    this.myColumnToggle = this.myColumnToggle.bind(this);

    // functions to handle end and start of new period
    this.handleStartEndPeriod = this.handleStartEndPeriod.bind(this);
    this.endPeriodAlert = this.endPeriodAlert.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.toggleNewPeriodModal = this.toggleNewPeriodModal.bind(this);
    this.handleValidPeriodSubmit = this.handleValidPeriodSubmit.bind(this);

    // functions to handle new order creation
    this.handleNewOrderClick = this.handleNewOrderClick.bind(this);
    this.handleEditOrderClick = this.handleEditOrderClick.bind(this);
    this.handleEditReceivedClick = this.handleEditReceivedClick.bind(this);
    this.handleCopyOrderClick = this.handleCopyOrderClick.bind(this);
    this.toggleNewOrderModal = this.toggleNewOrderModal.bind(this);
    this.toggleReceivedModal = this.toggleReceivedModal.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
    this.onChangeSender = this.onChangeSender.bind(this);
    this.setCountry = this.setCountry.bind(this);
    this.onChangePaymentStatus = this.onChangePaymentStatus.bind(this);
    this.onChangeSource = this.onChangeSource.bind(this);
    this.handleValidSalesOrderSubmit = this.handleValidSalesOrderSubmit.bind(this);
    this.checkExistingBattlefield = this.checkExistingBattlefield.bind(this);

    // function to handle accounting department actions
    this.handleValidAccOrderSubmit = this.handleValidAccOrderSubmit.bind(this);

    // functions to handle order deletion
    this.handleDeleteBattlefield = this.handleDeleteBattlefield.bind(this);
    this.deleteOrderAlert = this.deleteOrderAlert.bind(this);
  }

  componentDidMount() {
    window.addEventListener('load', getScreenHeight);
    window.addEventListener('click', getScreenHeight, { once: true });
    window.addEventListener('resize', getScreenHeight);

    // Join Battle Field Room
    socket.emit(WsEvents.battlefield.JOIN_ROOM, console.log);
  }
  componentWillUnmount() {
    window.removeEventListener('load', getScreenHeight);
    window.removeEventListener('click', getScreenHeight);
    window.removeEventListener('resize', getScreenHeight);

    // Leave Battle Field Room
    socket.emit(WsEvents.battlefield.LEAVE_ROOM, console.log);
  }
  /**
   * Display/Hide filter
   * @param {*} e
   */
  toggleStickyFilter(e) {
    let event = e.target.dataset.event;
    this.setState({
      collapse: this.state.collapse === Number(event) ? 0 : Number(event)
    });
    if (this.state.collapse === 1) {
      document.getElementById('tab').classList.remove('selected');
    } else {
      document.getElementById('tab').classList.add('selected');
    }
  }
  /**
   * Function to display orders only related to login person
   * @param {*} e
   */
  showAllOrders = (e) => {
    const { onGetBattlefield, profileData } = this.props.props;
    this.setState(
      (prevState) => ({ isChecked: !prevState.isChecked }),
      () => {
        const values = {
          _id: this.state.isChecked === true ? profileData._id : 'all'
        };
        onGetBattlefield(values);
      }
    );
  };
  /**
   * Function to change selected value of state
   * @param {*} e
   * @returns state for selected value
   */
  handleFilterChange = (e) => this.setState({ [e.target.name]: e.target.value });
  /**
   * Function to filter data from selected year/month/manager
   * @param {*} e
   * @param {array} values
   * @returns filtered data
   */
  handleFilterDataSubmit = (e, values) => {
    const { date } = this.props.props;
    const { onHideActionsToggle  } = this.props;
    const { onGetSpecificBattlefieldFilter } = this.props;
    const createOrderBtn = document.getElementById('create-order-btn');
    const myOrdersBtn = document.getElementById('myOrders');
    if (createOrderBtn && myOrdersBtn) {
      const isSameDate = values.year === date.year && values.month === date.month;
      if (onHideActionsToggle) {
        onHideActionsToggle(!isSameDate);
      }
      createOrderBtn.disabled = !isSameDate;
      myOrdersBtn.disabled = !isSameDate;
    }
    if (values['month'] === 'All') {
      values['month'] = null;
    }
    if (values['manager'] === '') {
      values['manager'] = null;
    }
    if (values['paymentMethodFilter'] === '') {
      values['paymentMethodFilter'] = null;
    }
    if (values['orderStatusFilter'] === '') {
      values['orderStatusFilter'] = null;
    }
    if (values.year === date.year && values.month === date.month && values.manager === null && values.paymentMethodFilter === null && values.orderStatusFilter === null) {
      this.resetFilterData(e);
    } else {
      onGetSpecificBattlefieldFilter(values);
    }
  };
  /**
   * Function to reset selected filer and load current data
   */
  resetFilterData = () => {
    const createOrderBtn = document.getElementById('create-order-btn');
    const myOrders = document.getElementById('myOrders');
  
    if (createOrderBtn) createOrderBtn.disabled = false;
    if (myOrders) myOrders.disabled = false;
    this.setState({ filtered_battles: [], year: this.props.props.date.year, month: this.props.props.date.month, manager: '', formKey: Math.random() });
    this.props.onStateChange('filter', this.state.filtered_battles);
  };
  /**
   * Toggle table columns
   * @param {*} df
   */
  myColumnToggle = (df) => {
    let newTableColumns = this.props.BattleFieldListColumns.map((val) => {
      if (val.dataField === df) {
        val.hidden = !val.hidden;
      }
      return val;
    });
    this.props.onStateChange('columns', newTableColumns);
    // this.setState({ newTableColumns: newTableColumns });
  };

  /**
   * Set new period to start or to end
   */
  handleStartEndPeriod = () => {
    if (!this.props.props.date.endDate) {
      const endDate = { endDate: new Date().toLocaleDateString('fr-CA') };
      const getAlertEnd = () => (
        <SweetAlert warning showCancel confirmBtnText='Yes, end it!' confirmBtnBsStyle='success' title='Are you sure?' onConfirm={() => this.endPeriodAlert()} onCancel={this.hideAlert} focusCancelBtn>
          This action will end the current period:
          <br />
          <span className='fw-bold'>{new Date(this.props.props.date.startDate).toLocaleDateString('fr-CA')}</span> - <span className='fw-bold'>{endDate.endDate}</span>
        </SweetAlert>
      );
      this.setState({ alert: getAlertEnd() });
    } else {
      this.toggleNewPeriodModal();
    }
  };
  /**
   * Set new period to end after alert confirmation
   */
  endPeriodAlert = () => {
    const { dispatch } = this.props.props;
    const endDate = { endDate: new Date().toLocaleDateString('fr-CA') };
    const updatePeriod = {
      startDate: this.props.props.date.startDate,
      endDate: endDate.endDate,
      period: 'finish'
    };
    onUpdateBattlefieldPeriod({ dispatch, battlefield: updatePeriod });
    this.hideAlert();
  };
  /**
   * @returns set state of alert to null
   */
  // hideAlert = () => this.setState({ alert: null });
  /**
   * @returns set period modal to open or close
   */
  toggleNewPeriodModal = () => this.setState((prevState) => ({ modalNewPeriod: !prevState.modalNewPeriod }));
  /**
   * Submit period data to backend
   * @param {*} e
   * @param {array} values
   */
  handleValidPeriodSubmit = (e, values) => {
    const { dispatch, years, months } = this.props.props;
    const endDate = { endDate: new Date().toLocaleDateString('fr-CA') };
    const updatePeriod = {
      startDate: this.props.props.date.startDate,
      year: values.year,
      month: values.month,
      endDate: endDate.endDate,
      period: 'start'
    };
    if (years.indexOf(values.year) === -1) {
      years.push(values.year);
    }
    if (months.indexOf(values.month) === -1) {
      months.push(values.month);
    }
    onUpdateBattlefieldPeriod({ dispatch, battlefield: updatePeriod });
    this.toggleNewPeriodModal();
  };
  /**
   * Empty battle array and set edit to false. Open new order modal
   */
  handleNewOrderClick = () => {
    this.setState({ battle: '', error: '', isEdit: false, isNewClicked: false });
    this.toggleNewOrderModal();
  };
  /**
   * Function to assign values of selected order to battles array for editing
   * @param {array} arg
   */
  handleEditOrderClick = (battle) => {
    const receivedDate = battle.receivedDate ? new Date(battle.receivedDate).toLocaleDateString('en-GB') : new Date().toLocaleDateString('en-GB');
    this.setState({
      battle: {
        _id: battle._id,
        manager: battle.manager,
        sender: battle.sender,
        clientName: battle.clientName,
        newClient: battle.newClient,
        invoiceNo: battle.invoiceNo,
        country: battle.country,
        region: battle.region,
        invoiceSum: battle.invoiceSum,
        paymentMethod: battle.paymentMethod,
        comments: battle.comments,
        paymentStatus: battle.paymentStatus,
        source: battle.source,
        amountReceived: battle.amountReceived,
        orderStatus: battle.orderStatus,
        notificationSent: battle.notificationSent
      },
      isEdit: true,
      isNewClicked: battle.newClient === true ? true : false,
      selectedCountry: battle.country,
      orderDate: new Date(battle.date).toLocaleDateString('en-GB'),
      receivedDate: receivedDate,
      error: ''
    });
    this.toggleNewOrderModal();
  };
  /**
   * Function to assign values of selected order to battles array for editing
   * @param {array} arg
   */
  handleEditReceivedClick = (battle) => {
    const receivedDate = battle.receivedDate ? new Date(battle.receivedDate).toLocaleDateString('en-GB') : new Date().toLocaleDateString('en-GB');
    this.setState({
      battle: {
        _id: battle._id,
        manager: battle.manager,
        sender: battle.sender,
        clientName: battle.clientName,
        newClient: battle.newClient,
        invoiceNo: battle.invoiceNo,
        country: battle.country,
        region: battle.region,
        invoiceSum: battle.invoiceSum,
        paymentMethod: battle.paymentMethod,
        comments: battle.comments,
        paymentStatus: battle.paymentStatus,
        source: battle.source,
        amountReceived: battle.amountReceived,
        orderStatus: battle.orderStatus,
        notificationSent: battle.notificationSent
      },
      isEdit: true,
      isNewClicked: battle.newClient === true ? true : false,
      selectedCountry: battle.country,
      orderDate: new Date(battle.date).toLocaleDateString('en-GB'),
      receivedDate: receivedDate,
      error: ''
    });
    this.toggleReceivedModal();
  };
  /**
   * Function to assign values of selected order to battles array for copying
   * @param {array} arg
   */
  handleCopyOrderClick = (battle) => {
    const receivedDate = battle.receivedDate ? new Date(battle.receivedDate).toLocaleDateString('fr-CA') : '';
    this.setState({
      battle: {
        date: new Date(battle.date).toLocaleDateString('fr-CA'),
        manager: battle.manager,
        sender: battle.sender,
        clientName: battle.clientName,
        newClient: battle.newClient,
        invoiceNo: battle.invoiceNo,
        country: battle.country,
        region: battle.region,
        invoiceSum: battle.invoiceSum,
        paymentMethod: battle.paymentMethod,
        comments: battle.comments,
        paymentStatus: battle.paymentStatus,
        source: battle.source,
        amountReceived: battle.amountReceived,
        orderStatus: battle.orderStatus,
        receivedDate: receivedDate
      },
      isEdit: false,
      selectedCountry: battle.country,
      error: ''
    });
    this.toggleNewOrderModal();
  };
  /**
   * Set new order modal to open or close
   */
  toggleNewOrderModal = () => this.setState((prevState) => ({ modalNewOrder: !prevState.modalNewOrder }));
  /**
   * Set new order modal to open or close
   */
  toggleReceivedModal = () => this.setState((prevState) => ({ modalReceivedPayment: !prevState.modalReceivedPayment }));
  /**
   * Function to handle date input
   * @param {*} event
   */
  onChangeValue = (event) => {
    if (parseFloat(event.target.value.substring(3, 5)) > 12) {
      this.setState({ correctDate: false });
    } else {
      this.setState({
        correctDate: true,
        [event.target.name]: event.target.value
      });
    }
  };
  /**
   * Function to handle sender input
   * @param {*} event
   */
  onChangeSender = (event) => this.setState({ clientName: event.target.value });
  /**
   * Function to set selected country on change
   * @param {*} event
   * @param {String} param1
   * @returns
   */
  setCountry = (event, { value }) => this.setState({ selectedCountry: value });
  /**
   * Function to check if payment status was changed
   * @param {*} event
   */
  onChangePaymentStatus = (event) => this.setState({ paymentStatus: event.target.value });
  /**
   * Function to check if source is Exhibition
   * @param {*} event
   */
  onChangeSource = (event) => this.setState({ source: event.target.value });
  /**
   * Check if battle is already exists in the table
   * @param {array} newBattle value with new battle invoice No
   * @returns true or false
   */
checkExistingBattlefield = (newBattle) => {
  const { battles } = this.props.props;
  const { filteredBattles, myFilteredBattles } = this.props;
  console.log(filteredBattles, myFilteredBattles);
  const allBattles = [
    ...battles,
    ...filteredBattles,
    ...myFilteredBattles,
  ];

  const uniqueBattles = [...new Map(allBattles.map((b) => [b._id, b])).values()];

  return uniqueBattles.some(
    (el) => el.invoiceNo === newBattle.invoiceNo && el._id !== newBattle._id
  );
};

  /**
   * Function to submit new order or edit current order
   * @param {*} e
   * @param {array} values
   */
  handleValidSalesOrderSubmit = (e, values) => {
    const { profileData, dispatch, date, managers } = this.props.props;
    const { isEdit, battle, orderDate, selectedCountry } = this.state;
    if (!selectedCountry) {
      this.setState({ countryError: true });
      return;
    }
    if (isEdit) {
      const fieldLabels = {
        date: "Date",
        manager: "Manager",
        sender: "Sender",
        clientName: "Client Name",
        newClient: "New Client",
        invoiceNo: "Invoice Number",
        country: "Country",
        region: "Region",
        invoiceSum: "Amount Sent",
        paymentMethod: "Payment Method",
        comments: "Comments",
        paymentStatus: "Payment Status",
        source: "Source",
        currAmountReceived: "Currency Amount Received"
      };
      let changes = "";
      Object.keys(fieldLabels).forEach(key => {
        let oldVal = battle?.[key];
        let newVal = values?.[key];
        // Special handling for manager
        if (key === "manager") {
          const oldManager = battle.manager;
          const newManager = managers.find(m => m._id === values.manager);
    
          oldVal = oldManager ? `${oldManager.fname} ${oldManager.sname}` : "N/A";
          newVal = newManager ? `${newManager.fname} ${newManager.sname}` : "N/A";
    
          if (oldManager?._id !== newManager?._id) {
            changes += `${fieldLabels[key]} was changed from "${oldVal}" to "${newVal}"\n`;
          }
          return;
        }
        if (key === "country") {
          oldVal = battle.country;
          newVal = selectedCountry
        }
        // Handle different data types
        if (
          (oldVal || newVal) && // at least one has value
          oldVal !== newVal &&  // values differ
          !(oldVal == null && newVal == null)
        ) {
          changes += `${fieldLabels[key]} was changed from "${oldVal ?? 'N/A'}" to "${newVal ?? 'N/A'}"\n`;
        }
      });
      let updateBattlefield = {
        _id: battle._id,
        date: orderDate.split('/').reverse().join('-'),
        manager: values.manager,
        sender: values.sender,
        clientName: values.clientName.trim(),
        newClient: values.newClient,
        invoiceNo: values.invoiceNo,
        country: selectedCountry,
        region: values.region,
        invoiceSum: values.invoiceSum === '' ? '0' : values.invoiceSum,
        paymentMethod: values.paymentMethod,
        comments: values.comments,
        paymentStatus: values.paymentStatus,
        source: values.source,
        amountReceived: values.amountReceived,
        currAmountReceived: values.currAmountReceived,
        orderStatus: values.orderStatus,
        notificationSent: values.notificationSent,
        receivedDate: values.receivedDate
      };
      if(profileData.department.depName !== 'Sales Department' && profileData._id !== battle.manager._id){
        updateBattlefield.changes = changes
        updateBattlefield.sendNotificationTo = battle.manager.bitrixID
        updateBattlefield.responsibleForChanges = profileData.fname+' '+profileData.sname
        managers.map((id) => {
          if (id._id === battle.manager._id) {
            updateBattlefield.man_fname = id.fname;
            updateBattlefield.man_sname = id.sname;
          }
        });
      }
      // updated order
      if (this.checkExistingBattlefield(updateBattlefield) === true) {
        this.setState({
          error: 'Order with this Invoice Number is already exists.'
        });
      } else {
        onUpdateBattlefield({ dispatch, order: updateBattlefield });
        this.setState({ error: '', paymentStatus: 'Not Paid' });
        this.toggleNewOrderModal();
      }
    } else {
      const newBattlefield = {
        date: orderDate.split('/').reverse().join('-'),
        manager: values['manager'],
        sender: values['sender'],
        clientName: values['clientName'].trim(),
        newClient: values['newClient'],
        invoiceNo: values['invoiceNo'],
        country: selectedCountry,
        region: values['region'],
        invoiceSum: values['invoiceSum'] === '' ? '0' : values['invoiceSum'],
        paymentMethod: values['paymentMethod'],
        comments: values['comments'],
        paymentStatus: values['paymentStatus'],
        source: values['source'],
        amountReceived: '',
        currAmountReceived: '',
        orderStatus: false,
        notificationSent: false,
        receivedDate: null,
        startDate: date.startDate,
        year: date.year,
        month: date.month
        // month: profileData.workEmail === 'aleksandra.li_sales@korupharma.com' ? 'April' : date.month
      };
      // save new order to battlefield
      if (this.checkExistingBattlefield(newBattlefield) === true) {
        this.setState({
          error: 'Order with this Invoice Number is already exists.'
        });
      } else {
        onAddBattlefield({ dispatch, order: newBattlefield });
        this.setState({ error: '', paymentStatus: 'Not Paid' });
        this.toggleNewOrderModal();
      }
    }
    this.setState({ countryError: false });
  };
  /**
   * Function to submit accounting information
   * @param {*} e
   * @param {array} values
   */
  handleValidAccOrderSubmit = (e, values) => {
    const { dispatch, managers } = this.props.props;
    const { battle, receivedDate } = this.state;
    const updateBattleAccounting = {
      _id: battle._id,
      invoiceNo: battle.invoiceNo,
      amountReceived: parseFloat(isNaN(values.amountReceived) ? values.amountReceived.replace(/,/g, '') : values.amountReceived),
      currAmountReceived: values.currAmountReceived,
      paymentMethod: values.paymentMethod,
      orderStatus: true,
      receivedDate: receivedDate.split('/').reverse().join('-'),
      receivedDateForNotification: receivedDate,
      sender: battle.sender,
      clientName: battle.clientName,
      newClient: values.newClient,
      invoiceSum: values.invoiceSum === '' ? '0' : values.invoiceSum,
      comments: values.comments,
      bitrixID: '',
      man_fname: '',
      man_sname: '',
      accountingSubmit: battle.notificationSent === true ? false : true,
      notificationSent: true
    };
    managers.map((id) => {
      if (id._id === battle.manager._id) {
        updateBattleAccounting['bitrixID'] = id.bitrixID;
        updateBattleAccounting['man_fname'] = id.fname;
        updateBattleAccounting['man_sname'] = id.sname;
      }
    });
    // updated order
    onUpdateBattlefield({ dispatch, order: updateBattleAccounting });
    this.toggleReceivedModal();
  };
  /**
   * Function to delete order from the table
   * @param {array} battle
   */
  handleDeleteBattlefield = (battle) => {
    const getAlert = () => (
      <SweetAlert
        danger
        showCancel
        confirmBtnText='Yes, delete it!'
        confirmBtnBsStyle='danger'
        title='Are you sure?'
        onConfirm={() => this.deleteOrderAlert([battle._id])}
        onCancel={this.hideAlert}
        focusCancelBtn
      >
        The order with Invoice
        <span className='fw-bold'> #{battle.invoiceNo}</span> will be deleted from the system!
      </SweetAlert>
    );

    this.setState({
      alert: getAlert()
    });
  };
  /**
   * Function to delete an order from table and hide alert
   * @param {array} battle
   */
  deleteOrderAlert = (battle) => {
    const { onDeleteManyBattlefields, dispatch } = this.props.props;
    let delArr = [];
    onDeleteBattlefield({ dispatch, battleFieldIds: battle });
    this.props.onStateChange('selected', delArr);
    this.hideAlert();
    this.props.hideAlert();
  };
  /**
   * @returns set state of alert to null
   */
  hideAlert = () => this.setState({ alert: null });
  render() {
    const { SearchBar } = Search;
    const { profileData, battles, years, months, date, managers } = this.props.props;
    console.log(years)
    const { toolkitprops, countryOptions, filteredBattles, loading } = this.props;
    const {
      cards,
      collapse,
      year,
      month,
      paymentMethodFilter,
      orderStatusFilter,
      alert,
      modalNewPeriod,
      modalNewOrder,
      modalReceivedPayment,
      isChecked,
      error,
      isEdit,
      isNewClicked,
      battle,
      orderDate,
      correctDate,
      receivedDate,
      clientName,
      selectedCountry
    } = this.state;
    const payment_methods =
      filteredBattles.length !== 0
        ? filteredBattles.filter((v, i, a) => a.findIndex((v2) => v2.paymentMethod === v.paymentMethod) === i)
        : battles.filter((v, i, a) => a.findIndex((v2) => v2.paymentMethod === v.paymentMethod) === i);
    const payment_statuses =
      filteredBattles.length !== 0
        ? filteredBattles.filter((v, i, a) => a.findIndex((v2) => v2.orderStatus === v.orderStatus) === i)
        : battles.filter((v, i, a) => a.findIndex((v2) => v2.orderStatus === v.orderStatus) === i);
    return (
      <div className='header-section' id='header-section'>
        {cards.map((index) => {
          return (
            <Card key={index} style={{ marginBottom: '5px' }} id='tab' className='selected'>
              <CardHeader
                id='tab_header'
                onClick={(event) => {
                  this.toggleStickyFilter(event);
                  getScreenHeight('click', collapse);
                }}
                data-event={index}
              >
                {/* <i className={collapse === 1 ? "mdi mdi-chevron-down mdi-24px" : "mdi mdi-chevron-right mdi-24px"}/>{collapse === 1 ? "Hide" : "Show"}  */}
              </CardHeader>
              <Collapse isOpen={collapse === index}>
                <CardBody>
                  <Row className='mb-2 searchBar'>
                    <Col md='3' sm='12' className='d-flex'>
                      <div className='search-box ms-2 mb-2 me-2 d-inline-block '>
                        <div className='position-relative'>
                          <SearchBar {...toolkitprops.searchProps} ref={this.props.searchInputRef}/>
                          <i className='bx bx-search-alt search-icon' />
                        </div>
                      </div>
                      {profileData.permissions.includes('battlefieldOrdersAccess') && (
                        <FormGroup className='d-flex ps-0 justify-content-between form-switch form-switch-lg form-group me-2'>
                          <Label for='myOrders'> My Orders </Label>
                          <Input name='myOrders' onChange={(e) => this.showAllOrders(e)} className='ms-4' id='myOrders' type='checkbox' checked={isChecked} />
                        </FormGroup>
                      )}
                      <Notification compData={battles} keyWord='battlefield' module='Bot Battlefield Notification' />
                    </Col>
                    <Col md={profileData.department.depName === 'Business Management Team' ? '6' : '4'} sm='12'>
                      <AvForm className='d-flex ' key={`${year}-${month}`} id='filter-date-form' onValidSubmit={this.handleFilterDataSubmit}>
                        <FormGroup className='me-1'>
                          <AvField type='select' name='year' id='year' className='form-select' onChange={this.handleFilterChange} value={year || date.year}>
                            {years.map((year, index) => (
                              <option key={index} value={year} className='fw-bold fs-5'>
                                {year}
                              </option>
                            ))}
                          </AvField>
                        </FormGroup>
                        <FormGroup className='me-1'>
                          <AvField type='select' name='month' className='form-select' onChange={this.handleFilterChange} value={month || date.month}>
                            {months.map((month, index) => (
                              <option key={index} value={month.month} className='fw-bold fs-5'>
                                {month.month}
                              </option>
                            ))}
                          </AvField>
                        </FormGroup>
                        <FormGroup className='me-1'>
                          <AvField type='select' name='manager' className='form-select' onChange={this.handleFilterChange}>
                            {profileData.department.depName !== 'Cosmetic Brand-Suppuru' && (<option value=''>All</option>)}
                            {managers
                              .filter(manager => {
                                // If department is "Sales Department", show all managers
                                if (profileData.department.depName === 'Sales Department') return true;

                                // If department is "Cosmetic Brand-Suppuru", show only managers from that department
                                if (profileData.department.depName === 'Cosmetic Brand-Suppuru') {
                                  return manager.department?.depName === 'Cosmetic Brand-Suppuru';
                                }

                                // Default: exclude all others (or customize as needed)
                                return true;
                              })
                              .map((manager, index) => (
                                <option key={index} className='fw-bold fs-5' value={manager._id}>
                                  {manager.fname} {manager.sname}
                                </option>
                              ))}
                          </AvField>
                        </FormGroup>
                        {profileData.department.depName === 'Business Management Team' && (
                          <>
                            <FormGroup className='me-1'>
                              <AvField type='select' name='paymentMethodFilter' className='form-select' onChange={this.handleFilterChange} value={paymentMethodFilter}>
                                <option value=''>All</option>
                                {payment_methods.map((method, index) => (
                                  <option key={index} className='fw-bold fs-5' value={method.paymentMethod}>
                                    {method.paymentMethod}
                                  </option>
                                ))}
                              </AvField>
                            </FormGroup>
                            <FormGroup className='me-1'>
                              <AvField type='select' name='orderStatusFilter' className='form-select' onChange={this.handleFilterChange} value={orderStatusFilter}>
                                <option value=''>All</option>
                                {payment_statuses.map((status, index) => (
                                  <option key={index} className='fw-bold fs-5' value={status.orderStatus}>
                                    {status.orderStatus ? 'Received' : 'Not Received'}
                                  </option>
                                ))}
                              </AvField>
                            </FormGroup>
                          </>
                        )}
                        <FormGroup className='me-1'>
                          <button className='btn btn-success save-user' id='dblclick'>
                            Filter
                          </button>
                        </FormGroup>
                        <FormGroup className=''>
                          <button type='reset' onClick={this.resetFilterData} className='btn btn-primary save-user'>
                            Resets
                          </button>
                        </FormGroup>
                      </AvForm>
                    </Col>
                    <Col md={profileData.department.depName === 'Business Management Team' ? '3 d-flex justify-content-between' : '5 d-flex justify-content-between'}>
                      <MyExportCSV {...toolkitprops.csvProps} />
                      <div className=''>
                        {profileData.permissions.includes('battlefieldBtnPeriodAccess') && (
                          <Button color='primary' className={!date.endDate ? ' btn-block btn btn-danger btn-lg ms-2' : ' btn-block btn btn-success btn-lg ms-2'} onClick={this.handleStartEndPeriod}>
                            {!date.endDate ? (
                              <>
                                <i className='mdi mdi-calendar-lock-outline me-1' /> End Current Month
                              </>
                            ) : (
                              <>
                                <i className='mdi mdi-calendar me-1' /> Start New Month
                              </>
                            )}
                          </Button>
                        )}
                        {/* Start new period modal window */}
                        <Modal size='sm' isOpen={modalNewPeriod} className={this.props.className} toggle={this.toggleNewPeriodModal}>
                          <ModalHeader toggle={this.toggleNewPeriodModal} tag='h4'>
                            Start New Period
                          </ModalHeader>
                          <ModalBody>
                            <AvForm onValidSubmit={this.handleValidPeriodSubmit}>
                              <Row>
                                <Col md={6}>
                                  <FormGroup className='mb-3'>
                                    <AvField
                                      type='select'
                                      name='year'
                                      className='form-select'
                                      label='Select Year'
                                      errorMessage='Please select year'
                                      validate={{
                                        required: {
                                          value: true
                                        }
                                      }}
                                      value='2024'
                                    >
                                      <option value='2020'>2020</option>
                                      <option value='2021'>2021</option>
                                      <option value='2022'>2022</option>
                                      <option value='2023'>2023</option>
                                      <option value='2024'>2024</option>
                                      <option value='2025'>2025</option>
                                      <option value='2026'>2026</option>
                                    </AvField>
                                  </FormGroup>
                                </Col>
                                <Col md={6}>
                                  <FormGroup className='mb-3'>
                                    <AvField
                                      type='select'
                                      name='month'
                                      className='form-select'
                                      label='Select Month'
                                      errorMessage='Please select month'
                                      validate={{
                                        required: {
                                          value: true
                                        }
                                      }}
                                    >
                                      <option>Choose</option>
                                      <option>January</option>
                                      <option>February</option>
                                      <option>March</option>
                                      <option>April</option>
                                      <option>May</option>
                                      <option>June</option>
                                      <option>July</option>
                                      <option>August</option>
                                      <option>September</option>
                                      <option>October</option>
                                      <option>November</option>
                                      <option>December</option>
                                    </AvField>
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <div className='text-end'>
                                    {loading && <BtnLoader />}
                                    <button className='btn btn-success save-user' disabled={loading && true}>
                                      Start New Month{' '}
                                    </button>
                                  </div>
                                </Col>
                              </Row>
                            </AvForm>
                          </ModalBody>
                        </Modal>
                      </div>
                      {profileData.permissions.includes('battlefieldBtnNewOrderAccess') && (
                        <div className='text-sm-end'>
                          {!date.endDate && (
                            <Button color='primary' className='font-16 btn-block btn btn-primary btn-lg' onClick={this.handleNewOrderClick} id='create-order-btn'>
                              <i className='mdi mdi-plus-circle-outline me-1' />
                              Create Order
                            </Button>
                          )}
                        </div>
                      )}
                      {/* Add/Edit new order modal window */}
                      {profileData.permissions.includes('battlefieldBtnNewOrderAccess') && (
                        <Modal size='xl' isOpen={modalNewOrder} className={this.props.className} toggle={this.toggleNewOrderModal}>
                          <ModalHeader toggle={this.toggleNewOrderModal} tag='h4'>
                            {!!isEdit ? 'Edit Order' : 'Add Order'}
                          </ModalHeader>
                          <ModalBody>
                            {error !== '' && error ? <Alert color='danger'> {error} </Alert> : null}
                            <AvForm onValidSubmit={this.handleValidSalesOrderSubmit}>
                              <Row>
                                <Col md={3}>
                                  <FormGroup className='mb-3'>
                                    <Label>Date</Label>
                                    <InputMask
                                      mask='99/99/9999'
                                      value={orderDate}
                                      name='orderDate'
                                      onChange={this.onChangeValue}
                                      className={correctDate ? ' form-control input-mask' : 'form-control input-mask is-invalid'}
                                    />
                                    {!correctDate && <div className='invalid-feedback'>Invalid Date. Please use dd/mm/yyyy format</div>}
                                  </FormGroup>
                                </Col>
                                <Col md={3}>
                                  <FormGroup className='mb-3'>
                                    <AvField
                                      type='select'
                                      name='manager'
                                      className='form-select'
                                      label='Manager'
                                      errorMessage='Please select manager'
                                      validate={{
                                        required: {
                                          value: true
                                        }
                                      }}
                                      value={battle.manager ? battle.manager._id : profileData._id}
                                    >
                                      <option>Choose</option>

                                      {managers.map((manager) => {
                                        return (
                                          <option key={manager._id} value={manager._id}>
                                            {manager.fname} {manager.sname}
                                          </option>
                                        );
                                      })}
                                    </AvField>
                                  </FormGroup>
                                </Col>
                                <Col md={3}>
                                  <FormGroup className='mb-3'>
                                    <AvField name='sender' label='Sender' type='text' autoComplete='off' onChange={this.onChangeSender} value={battle.sender || ''} />
                                  </FormGroup>
                                </Col>
                                <Col md={3}>
                                  <FormGroup className='mb-3'>
                                    <AvField
                                      name='clientName'
                                      id='clientName'
                                      label="Client's Name"
                                      type='text'
                                      errorMessage="Invalid Client's Name"
                                      autoComplete='off'
                                      validate={{
                                        required: {
                                          value: true
                                        }
                                      }}
                                      value={battle.clientName || clientName}
                                    />
                                  </FormGroup>
                                  <FormGroup className='mb-3 new-client'>
                                    <Label htmlFor='customCheckcolor1' className='form-check-label new-client-label'>
                                      <i className='mdi mdi-new-box mdi-24px' />
                                    </Label>
                                    <AvField
                                      name='newClient'
                                      type='checkbox'
                                      className='form-check-input new-client-input '
                                      id='customCheckcolor1'
                                      value={battle.newClient || ''}
                                      onClick={() => this.setState({ isNewClicked: !this.state.isNewClicked })}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={3}>
                                  <FormGroup className='mb-3'>
                                    <AvField
                                      name='invoiceNo'
                                      label='Invoice №'
                                      type='text'
                                      errorMessage='Invalid Invoice №'
                                      autoComplete='off'
                                      validate={{
                                        required: {
                                          value: true
                                        }
                                      }}
                                      value={battle.invoiceNo || ''}
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md={3}>
                                  <FormGroup className='mb-3'>
                                    <AvField name='invoiceSum' label='Amount Sent' autoComplete='off' type='number' value={battle.invoiceSum || 0} />
                                  </FormGroup>
                                </Col>
                                <Col md={3}>
                                  <FormGroup className='mb-3'>
                                    <Label htmlFor='country_selector'>Country</Label>
                                    <Dropdown
                                      placeholder='Select Country'
                                      fluid
                                      search
                                      selection
                                      options={countryOptions}
                                      name='country'
                                      required
                                      defaultValue={selectedCountry}
                                      onChange={this.setCountry}
                                      id='country_selector'
                                      error={this.state.countryError}
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md={3}>
                                  <FormGroup className='mb-3'>
                                    <AvField name='region' label='Region/City' autoComplete='off' type='text' value={battle.region || ''} />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={3}>
                                  <FormGroup className='mb-3'>
                                    <AvField
                                      name='paymentMethod'
                                      label='Payment method'
                                      autoComplete='off'
                                      type='select'
                                      value={battle.paymentMethod || ''}
                                      validate={
                                        this.state.paymentStatus !== 'Not Paid'
                                          ? {
                                              required: {
                                                value: true
                                              }
                                            }
                                          : {
                                              required: {
                                                value: false
                                              }
                                            }
                                      }
                                    >
                                        <option value='' disabled>
                                          -- Select a payment method --
                                        </option>
                                      {/* <datalist id='urls'> */}
                                        <optgroup label='Koru Pharma bank accounts'>
                                          <option>Woori Bank KRW</option>
                                          <option>Woori Bank USD/GBP/EUR/AUD</option>
                                          <option>Kookmin Bank KRW</option>
                                          <option>Kookmin Bank USD</option>
                                          <option>Shinhan Bank KRW</option>
                                          <option>Shinhan Bank USD</option>
                                          <option>Hana bank KRW</option>
                                          <option>Hana bank USD</option>
                                        </optgroup>
                                        <optgroup label='Card terminal + cash'>
                                          <option>Card Terminal</option>
                                          <option>Cash Korea</option>
                                          <option>Cash Malaysia</option>
                                          <option>Cash exhibition</option>
                                        </optgroup>
                                        <optgroup label='Other payments'>
                                          <option>Payoneer</option>
                                          <option>Western Union</option>
                                          <option>ONLINE</option>
                                        </optgroup>
                                        <optgroup label='Ukraine payments'>
                                          <option>Card UKR</option>
                                          <option>Cash UKR</option>
                                          <option>FOP UKR</option>
                                        </optgroup>
                                        <optgroup label='UAE payments'>
                                          <option>COD</option>
                                        </optgroup>
                                        {/*<option>On Exhibition</option>
                                        <option>Wechat</option>
                                           <option>Cash to Anatolii</option>
                                          <option>Cash to Sim Maksim</option>
                                          <option>Cash to Olga Kiev</option>
                                          <option>Cash to Denis Yaroshenko Kiev</option>
                                          <option>Cash to Andrey Myakushko Kiev</option>
                                          <option>Cash to Vitalii Serkin</option>
                                           <option>Payoneer AUD</option>
                                          <option>Payoneer CAD</option>
                                          <option>Payoneer EUR</option>
                                          <option>Payoneer GBP</option>
                                          <option>Payoneer JPY</option>
                                          <option>Payoneer USD</option> */}
                                      {/* </datalist> */}
                                    </AvField>
                                  </FormGroup>
                                </Col>
                                <Col md={3}>
                                  <FormGroup className='mb-3'>
                                    <AvField type='select' name='paymentStatus' className='form-select' label='Payment status' onChange={this.onChangePaymentStatus} value={battle.paymentStatus || ''}>
                                      <option>Not Paid</option>
                                      <option>Not Paid - Sent</option>
                                      <option>Paid</option>
                                      <option>Paid and Sent</option>
                                    </AvField>
                                  </FormGroup>
                                </Col>
                                <Col md={3}>
                                  <FormGroup className='mb-3'>
                                    <AvField name='comments' label='Commentary' autoComplete='off' type='text' value={battle.comments || ''} 
                                      validate={
                                        this.state.source !== 'Exhibition'
                                          ? {
                                              required: {
                                                value: false
                                              }
                                            }
                                          : {
                                              required: {
                                                value: true
                                              }
                                            }
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md={3}>
                                  <FormGroup className='mb-3'>
                                    <AvField
                                      type='select'
                                      name='source'
                                      className='form-select'
                                      label='Source'
                                      value={battle.source || ''}
                                      onChange={this.onChangeSource}
                                      required={isNewClicked}
                                      errorMessage='Please select the source'
                                    >
                                      <option value=''>-//-</option>
                                      <option>Korupharma Website</option>
                                      <option>Found by manager</option>
                                      <option>Jivo chat </option>
                                      <option>Recommendation</option>
                                      <option>Facebook</option>
                                      <option>Xiaohongshu</option>
                                      <option>Baidu</option>
                                      <option>Wechat</option>
                                      <option>Instagram</option>
                                      <option>Exhibition</option>
                                      <option>Email</option>
                                    </AvField>
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <div className='text-end'>
                                    {loading && <BtnLoader />}
                                    <button className='btn btn-success save-user' disabled={!correctDate || (loading && true)}>
                                      {!!isEdit ? 'Edit Order' : 'Add Order'}
                                    </button>
                                  </div>
                                </Col>
                              </Row>
                            </AvForm>
                          </ModalBody>
                        </Modal>
                      )}
                      {profileData.permissions.includes('battlefieldBtnReceivedAccess') &&  (
                        <Modal size='lg' isOpen={modalReceivedPayment} className={this.props.className} toggle={this.toggleReceivedModal}>
                          <ModalHeader toggle={this.toggleReceivedModal} tag='h4'>
                            Edit Order Status
                          </ModalHeader>
                          <ModalBody>
                            <AvForm onValidSubmit={this.handleValidAccOrderSubmit}>
                              <Row>
                                <Col md={6}>
                                  <FormGroup className='mb-3 ms-3 new-client'>
                                    <Label htmlFor='customCheckcolor1' className='form-check-label new-client-label'>
                                      <i className='mdi mdi-new-box mdi-24px' /> New Client
                                    </Label>
                                    <AvField
                                      name='newClient'
                                      type='checkbox'
                                      className='form-check-input new-client-input '
                                      id='customCheckcolor1'
                                      value={battle.newClient || ''}
                                      onClick={() => this.setState({ isNewClicked: !this.state.isNewClicked })}
                                    />
                                  </FormGroup>
                                  <FormGroup className='mb-3'>
                                    <AvField name='amountReceived' label='Amount Received' type='text' value={battle.amountReceived || ''} />
                                  </FormGroup>
                                </Col>
                                <Col md={6}>
                                  <FormGroup className='mb-3'>
                                    <AvField
                                      type='select'
                                      name='currAmountReceived'
                                      className='form-select'
                                      label='Currency'
                                      errorMessage='Please select currency'
                                      validate={{
                                        required: {
                                          value: true
                                        }
                                      }}
                                      value='₩'
                                    >
                                      <option value='₩'>₩ KRW</option>
                                      <option value='$'>$ USD</option>
                                      <option value='€'>€ EUR</option>
                                      <option value='AU$'>AU$ AUD</option>
                                      <option value='£'>£ GBP</option>
                                    </AvField>
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                  <FormGroup className='mb-3'>
                                    <AvField
                                      name='paymentMethod' 
                                      label='Payment method' 
                                      type='select'
                                      value={battle.paymentMethod || ''} 
                                      autoComplete='off'
                                    >
                                        <option value='' disabled>
                                          -- Select a payment method --
                                        </option>
                                        <optgroup label='Koru Pharma bank accounts'>
                                          <option>Woori Bank KRW</option>
                                          <option>Woori Bank USD/GBP/EUR/AUD</option>
                                          <option>Kookmin Bank KRW</option>
                                          <option>Kookmin Bank USD</option>
                                          <option>Shinhan Bank KRW</option>
                                          <option>Shinhan Bank USD</option>
                                          <option>Hana bank KRW</option>
                                          <option>Hana bank USD</option>
                                        </optgroup>
                                        <optgroup label='Card terminal + cash'>
                                          <option>Card Terminal</option>
                                          <option>Cash Korea</option>
                                          <option>Cash Malaysia</option>
                                          <option>Cash exhibition</option>
                                        </optgroup>
                                        <optgroup label='Other payments'>
                                          <option>Payoneer</option>
                                          <option>Western Union</option>
                                          <option>ONLINE</option>
                                        </optgroup>
                                        <optgroup label='Ukraine payments'>
                                          <option>Card UKR</option>
                                          <option>Cash UKR</option>
                                          <option>FOP UKR</option>
                                        </optgroup>
                                        <optgroup label='UAE payments'>
                                          <option>COD</option>
                                        </optgroup>
                                    </AvField>
                                    {/* <AvField name='paymentMethod' label='Payment method' value={battle.paymentMethod || ''} autoComplete='off' list='pms' />
                                    <datalist id='pms'>
                                      <optgroup label='Bank'>
                                        <option>Woori Bank USD/GBP/EUR/AUD</option>
                                        <option>Woori Bank KRW</option>
                                        <option>Kookmin Bank USD</option>
                                        <option>Kookmin Bank KRW</option>
                                        <option>Shinhan Bank USD</option>
                                      </optgroup>
                                      <optgroup label='Western Union'>
                                        <option>Vernidub Roman</option>
                                        <option>Western Union (WU)</option>
                                      </optgroup>
                                      <optgroup label='Cash'>
                                        <option>Cash to Anatolii</option>
                                        <option>Cash to Sim Maksim</option>
                                        <option>Cash to Olga Kiev</option>
                                        <option>Cash to Denis Yaroshenko Kiev</option>
                                        <option>Cash to Andrey Myakushko Kiev</option>
                                        <option>Cash to Vitalii Serkin</option>
                                      </optgroup>
                                      <optgroup label='Cryprocurrency'>
                                        <option>BTC</option>
                                        <option>ONLINE</option>
                                        <option>XRP</option>
                                      </optgroup>
                                      <option>Client's Card</option>
                                      <option>Wechat</option>
                                    </datalist> */}
                                  </FormGroup>
                                </Col>
                                <Col md={6}>
                                  <FormGroup className='mb-3'>
                                    <Label>Received Date</Label>
                                    <InputMask
                                      mask='99/99/9999'
                                      value={receivedDate}
                                      name='receivedDate'
                                      onChange={this.onChange}
                                      className={correctDate ? ' form-control input-mask' : 'form-control input-mask is-invalid'}
                                    />
                                    {!correctDate && <div className='invalid-feedback'>Invalid Date. Please use dd/mm/yyyy format</div>}
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                  <FormGroup className='mb-3'>
                                    <AvField name='invoiceSum' label='Amount Sent' autoComplete='off' type='number' value={battle.invoiceSum || 0} />
                                  </FormGroup>
                                </Col>
                                <Col md={6}>
                                  <FormGroup className='mb-3'>
                                    <AvField name='comments' label='Commentary' autoComplete='off' type='text' value={battle.comments || ''} />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <div className='text-end'>
                                    {loading && <BtnLoader />}
                                    <button className='btn btn-success save-user' disabled={!correctDate || (loading && true)}>
                                      Payment Received
                                    </button>
                                  </div>
                                </Col>
                              </Row>
                            </AvForm>
                          </ModalBody>
                        </Modal>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col md='12'>
                      <CustomToggleList {...toolkitprops.columnToggleProps} onColumnToggle={this.myColumnToggle} />
                    </Col>
                  </Row>
                  {alert}
                </CardBody>
              </Collapse>
            </Card>
          );
        })}
      </div>
    );
  }
}

export default FilterComp;
